<div class="modal-header">
  <h2>
    Agendar lote
  </h2>
</div>
<div *ngIf="!finalizado" class="modal-body">
  <div style="visibility: hidden; position: absolute; width: 0px; height: 0px;">
    <i class="mdi mdi-arrow-expand" id="expand-more"></i>
    <i class="mdi mdi-close" id="close"></i>
  </div>
  <p>Utilize a nossa planilha : <a (click)="baixarExemplo()"> <i class="mdi mdi-download"></i> baixar planilha</a> </p>
  <details closed>
    <summary class="principalSummary">
      Como usar ?
      <i class="mdi mdi-arrow-expand control-icon control-icon-expand" width="24" height="24" role="presentation"></i>
      <i class="mdi mdi-close control-icon control-icon-close" width="24" height="24" role="presentation"></i>
    </summary>
    <div class="d-flex flex-column">
      <Strong><label> Informações importantes ao preencher a planilha. </label></Strong>
      <br>
      <details open>
        <summary class="summarySecondary" >
          <span>Colunas </span> <strong>ClienteId, UnidadeId, VistoriadorId, ConfiguracaoId :</strong>
        </summary>
        Inserir somente os ID's dos usuarios e da configuração da vistoria.
      </details>
      <details open>
        <summary class="summarySecondary">
          <span>Coluna </span> <strong> DataAgendamento : </strong>
        </summary>
        Usar padrão dd/MM/yyyy ex: 23/10/2023.
      </details>
      <details open>
        <summary class="summarySecondary">
          <span>Coluna </span> <strong> Periodo : </strong>
        </summary>
        Preencher com o numero ' 0 ' para periodo da manhã ou numero ' 1 ' para periodo da tarde.
      </details>
      <details open>
        <summary class="summarySecondary">
          <span>Coluna </span> <strong> Numero : </strong>
        </summary>
        Inserir numero referente ao endereço do local da vistoria.
      </details>
      <details open>
        <summary class="summarySecondary">
          <span>Coluna </span> <strong> DesejaIntegrar : </strong>
        </summary>
        Referente a integração HG. Preencher numero ' 0 ' caso não tenha integração, ou ' 1 ' para integrar com HG.
      </details>
      <br>
      <p>* Caso duvidas, entrar em contato com nosso suporte.</p>
    </div>
  </details>
  <br>
  <p *ngIf="acimaDoLimite" style="color: red;"> Enviar no maximo 100 agendamentos por vez </p>
  <div class="card">
    <Strong><label >Enviar arquivo excel preenchido.</label></Strong>
    <div>
      <div class="file-upload">
        <div class="file-select">
          <div class="file-select-button" id="fileName"><i class="mdi mdi-upload"></i> Escolher arquivo</div>
          <div class="file-select-name" id="noFile">{{file == null ?  'Nenhum arquivo adicionado' : file.name}}</div>
          <input type="file" name="chooseFile" id="chooseFile" (change)="onFileChange($event)" accept=".xlsx, .xls">
        </div>
      </div>
    </div>
  </div>
</div>
<div *ngIf="finalizado" class="modal-body">
  <h2 class="d-flex justify-content-center"> Lote finalizado! </h2>
    <br>
  <div class="card">
    <div class="relatorio qtdLote">
      <span class=" qtdBase">Total de agendamentos : </span><Strong class="qtdLote qtd">{{listaAgendamentos.length}}</Strong>
    </div>
    <div class="relatorio qtdOk">
      <span class=" qtdBase"><i class="icon icon-success"></i>quantidade de agendamentos realizado : </span><Strong class="qtdOk qtd">{{listaAgendamentosSemErro.length}}</Strong>
    </div>
    <div class="relatorio qtdErro">
      <span class=" qtdBase"><i class="icon icon-danger"></i>quantidade de agendamentos com erros e não agendado :</span><Strong class="qtdErro qtd">{{listaAgendamentosComErro.length}}</Strong>
    </div>
  </div>
  <div class="listaErro" *ngIf="listaAgendamentosComErro.length > 0">
    <h3>Agendamentos com erros:</h3>
    <ul>
      <li *ngFor="let agendamento of listaAgendamentosComErro">
        <p><Strong>Placa: </Strong>{{ agendamento.veiculo.placa }} <Strong *ngIf="agendamento.veiculo.marca">Marca/Modelo:</Strong> {{agendamento.veiculo.marca}}/{{agendamento.veiculo.modelo}}</p>
      </li>
    </ul>
    <span class="obs">*Caso duvidas no preenchimento da planilha excel, favor entrar em contato com nosso suporte</span>
  </div>
</div>
<div class="modal-footer d-flex justify-content-between">
  <button (click)="activeModal.close(false)" class="btn btn-secondary px-lg-5">Fechar</button>
  <button (click)="tratarArquivo(file)" [hidden]="finalizado" [disabled]="file == null || finalizado" class="btn btn-success px-5">Confirmar</button>
</div>

